// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.entities[data-v-90730de8] {

    text-align: center
}
@media (min-width: 996px) {
.entities[data-v-90730de8] {

        display: flex;

        flex-direction: row;

        align-items: center;

        justify-content: center;

        gap: 1.5rem
}
}
.entities img[data-v-90730de8] {

    margin: 1rem;

    display: inline-block;

    height: 1.25rem
}
@media (min-width: 996px) {
.entities img[data-v-90730de8] {

        margin: 0
}
}
.entities img.taller[data-v-90730de8] {

    height: 4.125rem
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/Entities.vue"],"names":[],"mappings":";AAWA;;IAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA,mBAAA;;QAAA,mBAAA;;QAAA,uBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,YAAA;;IAAA,qBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"entities\">\n    <img src=\"img/landings/banco_espana_white.svg\" alt=\"Banco de España\" />\n    <img src=\"img/landings/api_white.svg\" alt=\"Asociación de agentes inmobiliarios\" />\n    <img src=\"img/landings/fotocasa_white.webp\" alt=\"Fotocasa\" />\n    <img class=\"taller\" src=\"img/landings/enisa.webp\" alt=\"Enisa\" />\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.entities {\n  @apply text-center lg:flex lg:flex-row lg:items-center lg:justify-center lg:gap-xxs;\n\n  img {\n    @apply h-[1.25rem] m-xxxs lg:m-0 inline-block;\n\n    &.taller {\n      @apply h-[4.125rem];\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
